<template>
  <div class="descriptionOfPack">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.ReportsDetail.PACKING_INFORMATION') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_1') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.cartonseal"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.cartonseal"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_2') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.frontmark"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.frontmark"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_3') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.sidemark"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.sidemark"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_4') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.cartonbarcode"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.cartonbarcode"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_5') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.cartonsize"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.cartonsize"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_6') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.cartonweight"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.cartonweight"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_7') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.innerpack"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.innerpack"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_8') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.cartonlayer"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.cartonlayer"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>

    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_9') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.innerbox"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfPack.innerbox"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>

    <!-- <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_1') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.packdetail"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
      
      </div>
    </div> -->
    <!-- <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Inner_Packing_Size') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.packsize"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
      </div>
    </div> -->
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Accessory_Manual_Polybag') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.other"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-table">
      <a-table
        class="desOfGoods-table1"
        :columns="columns"
        :dataSource="details"
        bordered
        :pagination="false"
        rowKey="id"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
// const data = [
//   {
//     street: 12,
//     street7: 23112,
//     street1: 321,
//     street2: 312,
//     street3: 312,
//     street4: 312,
//     street5: 312,
//   },
// ];
import showImg from './showImg';
export default {
  data() {
    return {
      columns: [
        {
          title: this.$tc('lang.ReportsDetail.CartonSize'),
          dataIndex: 'ireportCartonsize',
          key: 'ireportCartonsize',
        },
        {
          title: this.$tc('lang.ReportsDetail.CartonWeight'),
          dataIndex: 'ireportCartonweight',
          key: 'ireportCartonweight',
        },
        {
          title: this.$tc(
            'lang.ReportsDetail.Packing_Detail_For_Shipping_Carton',
          ),
          dataIndex: 'ireportCartonseal',
          key: 'ireportCartonseal',
        },
        {
          title: this.$tc('lang.ReportsDetail.Unit_Packing_Detail'),
          dataIndex: 'ireportPackinfo',
          key: 'ireportPackinfo',
        },
        {
          title: this.$tc('lang.ReportsDetail.Product_Packing_Size'),
          dataIndex: 'ireportPacksize',
          key: 'ireportPacksize',
        },
      ],
      // data,
    };
  },
  components: {
    showImg,
  },
  computed: {
    details: {
      get() {
        return [JSON.parse(JSON.stringify(this.$store.state.report.details))];
      },
    },
    descriptionOfPack: {
      get() {
        return this.$store.state.report.imgList.descriptionOfPack;
      },
    },
  },
};
</script>
<style lang="less">
.descriptionOfPack {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 180px;
      text-align: left;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
